<template>
  <div class="box-sin-aplicar">
    <div>{{ item.fecha }}</div>
    <div style="font-size:12px; text-transform: uppercase;">
      {{ item.local }} vs {{ item.visita }}
    </div>
    <div>{{ item.total }} {{ label }}</div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    label: String,
  },
}
</script>
<style lang="scss">
.box-sin-aplicar {
  background-color: rgb(223, 221, 221);
  width: auto;
  height: 80px;
  margin: 10px;
  padding: 4px;
  border-radius: 4px;
}
</style>
